import card from '../addable-card.png';
import { HelpModal } from './HelpModal';
import { useSwitch } from './SwitchHook';

const EmptyCard = () => {
    const [isModalOpen, modalOperation] = useSwitch(false);

    return <>
        <div className='card-element empty-card'>
            <div className="d-flex justify-content-around align-items-center">
                &nbsp;
            </div>
            <img className='card-image' src={card} alt="カードを追加" onClick={modalOperation.on} />
            <HelpModal isOpen={isModalOpen} onClose={modalOperation.off} />
        </div>
    </>;
};

export default EmptyCard;